// import logo from './logo.svg';
import './App.css';

import "./carousel.css";
import "./floating.css"
// import "./scrollEffect.css";
// import "./defaultScrollEffect.css";

import "./clients.css";
import "./scrollAnimation.css";

// import "./clientsCards.css"

import "./imageSlider.css"

import "./carouselHorizontal.css";

import "./navBarTop.css";
import "./navBarBottom.css";

import React, { useEffect, useRef, useState } from 'react';

function ScrollAnimation() {

  useEffect(() => {


    const boxes = document.querySelectorAll(".box");


    console.log("boxes", boxes)

    window.addEventListener("scroll", checkBoxes);


    checkBoxes();



    function checkBoxes() {
      const triggerBottom = (window.innerHeight / 5) * 4;

      boxes.forEach((box) => {
        const boxTop = box.getBoundingClientRect().top;
        //  const boxBottom = box.getBoundingClientRect().bottom; // testing things out. Don't use this.
        //  console.log("boxTop = ", boxTop, "triggerBottom = ", triggerBottom);

        if (boxTop < triggerBottom) {
          box.classList.add("show");
        }
        else {
          // console.log("Removing show on scroll animation.")
          box.classList.remove("show");
        }
      });
    }

  }, []);


  return (
    <>

    </>
  );
}

function App() {
  return (
    <>
      {/* <Background /> */}
      <NavBarTop />
      <Floating />
      <Slider />
      <Credentials />
      <Clients />
      {/* <Contact /> */}
    </>

  );
}

function NavBarTop() {

  useEffect(() => {

    function checkScrollTop() {
      if (window.scrollY >= stickyTop) {
        navbarTop.classList.add("stickyTop")
        navbarBottom.classList.add("stickyBottom")
      } else {
        navbarTop.classList.remove("stickyTop");
        navbarBottom.classList.remove("stickyBottom");
      }
    }

    window.onscroll = function () { checkScrollTop() };

    var navbarTop = document.getElementById("navbarTop");
    var stickyTop = navbarTop.offsetTop;

    var navbarBottom = document.getElementById("navbarBottom");


  }, []);




  return (
    <>
      {/* navbar TOP */}
      <div id="navbarTop">
        <p className="navbarTopPara">Stephen Anderson</p>
        <p className="navbarTopPara">Full-Stack Web Developer</p>
        <a class="active navBarLinkRight" href="mailto:Steve@andersonwebmarketing.ca">Steve@andersonwebmarketing.ca</a>
      </div>

      {/* navbar Bottom */}
      <div id="navbarBottom">

        <a href="https://github.com/HifiAudi0" target="_blank" rel="noreferrer">
          <img id="githubIcon" className="contactIcon" src="./img/github-icon-v3.png" alt="A GitHub Icon that links to my GitHub profile." /></a>
        <h3 className="navbarBottomHeading navbarBottomLeftSideText">Let's Connect!</h3>
        <h3 className="navbarBottomHeading navbarBottomRightSideText">Updated in 2025</h3>
        <a href="https://www.linkedin.com/in/stephenanderson-587/" target="_blank" rel="noreferrer">
          <img id="linkedinIcon" className="contactIcon" src="./img/linkedIn-icon.png" alt="A LinkedIn Icon that links to my LinkedIn profile." /></a>
        {/* <a href="mailto:stephen.and@outlook.com"><img id="mailIcon" className="contactIcon" src="./img/mail.png" alt="" /></a> */}

      </div >

    </>
  );

}


function Background() {
  return (
    <>
      <div className="wrapper">
        <video id="background-video" playsInline autoPlay loop muted>
          <source id="video-src" src="./img/codeing-bg-v2.mov" type="video/mp4">
          </source>
          Did not load video.
        </video>
      </div>

    </>
  );
}

function Clients() {
  // Array of client data, each with multiple images
  const clients = [
    {
      label: 'Monteiro Homes',
      logo: './img/monthomes-logo.png',
      images: [
        './img/clients/monthomes-1.png',
        './img/clients/monthomes-2.png',
        './img/clients/monthomes-3.png',
        './img/clients/monthomes-4.png',
        './img/clients/monthomes-5.png',
      ],
    },
    {
      label: 'Swear Free Videos',
      logo: './img/swearfreevideos-logo.png',
      images: [
        './img/clients/swearFreeVideos-screenshot.png',
        './img/clients/swearFreeVideos-screenshot-v2.png',
      ],
    },
    {
      label: 'Gibsons',
      logo: './img/clients/Gibsons-512-×-200-px.png',
      images: [
        './img/clients/websites/gibsons.jpg',
      ],
    },
    {
      label: 'Blue Mountain Adventure Tours',
      logo: './img/clients/BlueMontainAdventureTours.png',
      images: [
        './img/clients/websites/BlueMountainAndCollingwood.jpg',
      ],
    },
    {
      label: 'North49',
      logo: './img/clients/North49.jpg',
      images: [
        './img/clients/websites/North49.jpg',
      ],
    },
    {
      label: 'Zamzows',
      logo: './img/clients/zamzows.webp',
      images: [
        './img/clients/websites/Zamzzows.jpg',
      ],
    },
    {
      label: 'Adventuretown',
      logo: './img/clients/Adventuretown.png',
      images: [
        './img/clients/websites/Adventuretown.jpg',
      ],
    },
    {
      label: 'Product Reviews',
      logo: './img/productReviewsLogo.png',
      images: [
        './img/clients/swearFreeVideos-screenshot-v2.png', // Placeholder, replace with real images
      ],
    },
  ];

  const [currentClient, setCurrentClient] = useState(0);
  const [currentImage, setCurrentImage] = useState(0);

  // When client changes, reset image to 0
  useEffect(() => {
    setCurrentImage(0);
  }, [currentClient]);

  const goLeft = () => {
    setCurrentImage((prev) =>
      prev === 0 ? clients[currentClient].images.length - 1 : prev - 1
    );
  };
  const goRight = () => {
    setCurrentImage((prev) =>
      prev === clients[currentClient].images.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <div className="scrollAnimation">
      <ScrollAnimation />
      <div className="box clientsSliderSection">
        <div className="pageMainHeading">
          <h2 className="pageMainHeadingText">CLIENTS</h2>
        </div>
        <div className="clientSliderIconsRow">
          {clients.map((client, idx) => (
            <button
              key={client.label}
              className={`clientSliderIconBtn${idx === currentClient ? ' active' : ''}`}
              onClick={() => setCurrentClient(idx)}
              aria-label={client.label}
            >
              <img
                src={client.logo}
                alt={client.label + ' logo'}
                className="clientSliderIconImg"
              />
            </button>
          ))}
        </div>
        <div className="clientSliderWrapper">
          <button className="clientSliderArrow left" onClick={goLeft} aria-label="Previous image">&#8592;</button>
          <div className="clientSliderImageContainer">
            {clients[currentClient].label === 'Product Reviews' ? (
              <iframe
                className="clientSliderVideoIframe"
                src="https://www.youtube.com/embed/-cquqAXgIyk?si=jEdWXiA9EnOShDfg"
                title="Product Review Demo Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen;"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                style={{ borderRadius: '20px', background: '#000' }}
              ></iframe>
            ) : (
              <img
                src={clients[currentClient].images[currentImage]}
                alt={clients[currentClient].label + ' screenshot'}
                className="clientSliderImage"
              />
            )}
            <div className="clientSliderLabel">{clients[currentClient].label}</div>
            {clients[currentClient].label !== 'Product Reviews' && (
              <div className="clientSliderImageCount">
                {currentImage + 1} / {clients[currentClient].images.length}
              </div>
            )}
          </div>
          <button className="clientSliderArrow right" onClick={goRight} aria-label="Next image">&#8594;</button>
        </div>
      </div>
    </div>
  );
}

function Credentials() {
  return (
    <>
      <div className="scrollAnimation">
        <ScrollAnimation />
        <div className="box credentialsSection">
          <div className="pageMainHeading">
            <h2 className="pageMainHeadingText">CREDENTIALS</h2>
          </div>
          <div className="logoCenter">
            <img className="logoMain" src="./img/andersonLogo.png" alt="The Anderson Web Marketing logo" />
          </div>
          <div className="credentialsCardsWrapper">
            <div className="credentialsCard">
              <div className="credentials-card-container">
                <h1>Diploma</h1>
                <h3>In Full-Stack Web Developer</h3>
                <h3>From McMaster University</h3>
              </div>
            </div>
            <div className="credentialsCard">
              <div className="credentials-card-container" id="diffColor" >
                <h1>Diploma</h1>
                <h3>In Marketing</h3>
                <h3>From McMaster University</h3>
              </div>
            </div>
            <div className="credentialsCard">
              <div className="credentials-card-container">
                <h1>Certification</h1>
                <h3>In Web Design</h3>
                <h3>From McMaster University</h3>
              </div>
            </div>
            <div className="credentialsCard">
              <div className="credentials-card-container" id="diffColor">
                <h1>Certification</h1>
                <h3>In Digital Marketing</h3>
                <h3>From McMaster University</h3>
              </div>
            </div>
            <div className="credentialsCard">
              <div className="credentials-card-container">
                <h1>Certification</h1>
                <h3>In Cloud Computing</h3>
                <h3>From University of Toronto</h3>
              </div>
            </div>
            <div className="credentialsCard">
              <div className="credentials-card-container" id="diffColor">
                <h1>Certification</h1>
                <h3>In Supply Chain Management</h3>
                <h3>From George Brown</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function Slider() {
  return (
    <>
      <div className="scrollAnimation">

        <ScrollAnimation />


        <div className="box">

          <h1 className="experiencedIn header">MOST EXPERIENCED IN:</h1>
          <div className="slider">
            <div className="slide-track">
              <div className="slide">
                <img src="./img/html-icon-2.png" height="80" width="50" alt="" />
              </div>
              <div className="slide">
                <img src="./img/css-icon-2.png" height="80" width="50" alt="" />
              </div>
              <div className="slide">
                <img src="./img/js-icon-2.png" height="80" width="50" alt="" />
              </div>
              <div className="slide">
                <img src="./img/react-icon-3.png" height="80" width="50" alt="" />
              </div>
              <div className="slide">
                <img src="./img/node-icon-2.png" height="80" width="150" alt="" />
              </div>
              <div className="slide">
                <img id="sliderGithubIcon" src="./img/github-icon-2.png" height="80" width="80" alt="" />
              </div>
              <div className="slide">
                <img id="sliderGithubIcon" src="./img/mysql-icon-v2.png" height="80" width="80" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function Floating() {
  return (
    <>
      <div className="scrollAnimation">

        <ScrollAnimation />


        <div className="box">

          <div className="container">
            <div className="avatar">
              <img src="./img/animated-me.png" alt="A.I. generated pic of myself." />
            </div>
            <h1 className="header">Hi, I'm Stephen Anderson.<br />A <span className="purpleBlueGradient">Full Stack Web Developer.</span></h1>
          </div>
        </div>
      </div>
    </>
  )
}

// function Contact() {
//   return (
//     <>

//       <div className="scrollAnimation">

//         <ScrollAnimation />


//         <div className="box">

//           <h1 className="header">CONTACT</h1>



//           <img id="contactBgImage" className="credentialsCardBg rounded-shadow" src="./img/cards.png" />

//           <a href="https://www.linkedin.com/in/stephenanderson-587/" target="_blank"><img id="githubIcon" className="contactIcon" src="./img/github-icon-v3.png" alt="" /></a>
//           <a href="https://www.linkedin.com/in/stephenanderson-587/" target="_blank"><img id="linkedinIcon" className="contactIcon" src="./img/linkedIn-icon.png" alt="" /></a>
//           <a href="mailto:stephen.and@outlook.com"><img id="mailIcon" className="contactIcon" src="./img/mail.png" alt="" /></a>

//           <img className="logo" src="./img/andersonLogo.png" />

//         </div>
//       </div>
//       <br /><br />
//     </>
//   );
// }

export default App;
